export default __webpack_public_path__ + "2f00bc1180568a4a815592839bbd2f93.png";